module.exports = __webpack_public_path__ + "img/SKMG14_map2.92d85250.jpg";